<template>
  <div class="place-order">
    <header-com/>
    <order-header :title="enoughNowTag?'立即购买':'购物袋（' + bagNum +  '）'" @choseAdr='choseAdr' :model='adrList'/>
    <div class="goods">
      <li v-for='(item,index) in detail.curingServiceList' :class='{border_b:index!=detail.curingServiceList.length -1}'>
        <div class="select" @click='changeRadio(index,item)' v-if='!enoughNowTag'>
          <radio1 :checked='item.checkRadio' class='radio_top'/>
        </div>
        <div class="img" @click='changeRadio(index,item)'>
          <img src="" alt="" v-lazy="formatImgUrl(item.pic,300,300,true)"/>
        </div>
        <div class="info">
          <div class='name_content'>
            <div class="name oneClamp">{{item.name}}</div>
            <div class='f24 number_name'>{{'¥' + item.price}} <span>x{{item.buyQuantity}}</span></div>
          </div>
          
          <div class="category f24 grey9">品类:{{item.categoryName}}</div>
          <div class="tool-bar">
            <div>
              <num-count
                :num="item.buyQuantity"
                @minus ='numberChange(0,item)'
                @plus="numberChange(1,item)" 
                v-if='!enoughNowTag'
                />
            </div>
            <div class="total-amount f32"><span class="f26">¥</span>{{item.buyQuantity*item.price}}</div>
          </div>
        </div>
      </li>
    </div>
    <div class='line_bg'>

    </div>
    <div class="list" v-if='detail.curingServiceList.length != 0'>
      <li>
        <div class="left">
          <span>养护数量</span>
        </div>
        <div  v-if='!enoughNowTag' class="right rightPicker" style='width:100px' @click='show = true' :class="{colorGrey:defaultIndex == '请选择'}">
          {{defaultIndex=='请选择'?defaultIndex:defaultIndex + '件'}}
        </div>
      </li>
      <li style='border:none;margin-top:10px'>
          <van-field
            @blur="inputBlur"
            v-model="remark"
            type="textarea"
            placeholder="还有什么要交待的？这里留言"
            rows="5"
            :clearable="true"
            autosize
          />
         
      </li>
    </div>
    
    <div v-else>
      <img src='/images/base/no-bag.png' class='no-list'>
      <div class='no_content'>
        <button class="primary" @click="$router.push({name:'homeList',query:{actionTab:3}})">去选购</button>
      </div>
    </div>

    <div class="g-fixed-bottom1 toolbar" v-show='detail.curingServiceList.length != 0'>
      <div class='left_cont'>
        订单金额：¥<span>{{detail.realAmount}}</span>
      </div>
      
      <div class='right_cont' style='float:right'>
        <!-- <img src="/images/public/bag_del.png" alt="" class='del_img' @click='clearBag' v-if='!enoughNowTag'/> -->
        <button class="primary margin0" @click='submitCart' :disabled='detail.curingServiceList.length == 0 || bagNum == 0'>{{enoughNowTag?'立即购买':'立即预约'}}</button>
      </div>
    </div>
    <!-- 选择地址 -->
    <van-popup position="bottom" v-model="adrShow">
      <div class="containerAdr f28">
        <div class="title">选择地址</div>
        <!-- <span @click="$router.push({ name: 'addressEdit'})">添加地址</span> -->
        <div class="close" @click="adrShow = false"></div>
        <div class="addr-container">
          <ul>
            <li v-for='(item,index) in adrList' :key='index' @click='adrClick(index)'>
              <div class='li_div'>
                 <radio :checked='item.isDefault'/>
              </div>
              <addr-com :model='item' :selected='item.trueDefault'/>
            </li>
          </ul>
        </div>
        <button class="primary fl" @click="$router.push({ name: 'addressEdit'})">添加地址</button>
      </div>
    </van-popup>

    <van-popup v-model="show" position="bottom" :overlay="true" >
      <van-picker :columns="columns" 
        show-toolbar
        @cancel="onCancel"
        :default-index="defaultIndex"
        @confirm="onConfirm"

      />
    </van-popup>
  </div>
</template>

<script>
  import homeApi from '@/axios/home'
  import publicObj from '@/assets/js/public'
  import myApi from '@/axios/my'
  import { Toast , Dialog} from 'vant';
  import zhugeObj from '@/assets/js/track';
  export default {
    name: 'index',
    data () {
      return {
        show : false,
        bagQuantity : '',
        defaultIndex:'请选择',
        adrList : [],
        remark : '',
        adrShow: false,
        columns : [],
        num: 0,
        detail : {
          curingServiceList : []
        },
        enoughNowTag : false,
        enoughNow:{
          curingServiceId : ''
        },
        enterComfirm : false
      }
    },
    computed: {
      defaultImg () {
        return this.DEFAULT_IMG
      },
      bagNum(){
        let totle = 0;
        this.detail.curingServiceList.forEach(element => {
          if(element.checkRadio){
             totle += element.buyQuantity;
          }
        });
        return totle;
      },
    },
    created(){
      this.getAdressList();
      for(let i=1;i<=50;i++){
        this.columns.push(i);
      }
      if(this.$route.query.curingServiceId){
        this.enoughNow = {
          curingServiceId : this.$route.query.curingServiceId,
          buyQuantity : this.$route.query.buyQuantity
        }
        this.enoughNowTag = true;
      }
    },
    methods : {
      inputBlur(){
        publicObj.IPhoneXHack()
      },
      onConfirm(value, index){
        this.defaultIndex = value;
        this.show = false;
        if(this.enterComfirm){
          this.submitCart();
        }
      },
      onCancel(){
        this.enterComfirm = false;
        this.show = false;
      },
      changeRadio(index,item){
        this.detail.curingServiceList[index].checkRadio = !this.detail.curingServiceList[index].checkRadio;

        let params = {
          curingServiceId : item.id,
          selected : this.detail.curingServiceList[index].checkRadio?1:0
        }
        
        Toast.loading({
          message: '拼命加载中...',
          duration: 0,
          forbidClick: true, // 禁用背景点击
          // loadingType: 'spinner',
        })

        homeApi.updataShoppingCart(params).then((res)=>{
          this.getShoppingCart();
          Toast.clear();
        }).catch(()=>{
          Toast.clear();
        })
      },
      formatImgUrl(url, width, height,m_fill) {
        // console.log(url)
        if (url) {
          url = url.replace('h_{height},w_{width}', "h_" + height + ",w_" + width + "");
          // url = url.replace(',jpg', ",webp");
          url +=',q_80';
          if(m_fill){
            // console.log(m_fill)
            url = url.replace('m_lfit', "m_fill");
          }
        }
        return url
      },
      clearBag(){
        Dialog.confirm({
          title: '',
          message: '您确认清空购物车?'
        }).then(() => {
          homeApi.clearBag().then((res)=>{
            this.getAdressList();
          })
        }).catch(() => {
          // on cancel
        });
      },
      numberChange(type,item){
        let buyQuantity;
        if(type){
          buyQuantity = item.buyQuantity + 1;
        }else{
          buyQuantity = item.buyQuantity - 1;
        }
        let params = {
          curingServiceId : item.id,
          buyQuantity : buyQuantity
        }
        
        Toast.loading({
          message: '拼命加载中...',
          duration: 0,
          forbidClick: true, // 禁用背景点击
          // loadingType: 'spinner',
        })
        homeApi.updataShoppingCart(params).then((res)=>{
          this.getShoppingCart();
          Toast.clear();
        }).catch(()=>{
          Toast.clear();
        })

      },
      submitCart(){
        if(this.defaultIndex == '请选择'){
          Toast('请您选择养护数量');
          this.show = true;
          this.enterComfirm = true;
          return;
        };
        let params = {
          remarks : this.remark,
          bagQuantity : this.defaultIndex,
          pickingWay: 10,
          action : 'normal'
        };
        
        if(this.enoughNowTag){
          params.curingServiceId = this.enoughNow.curingServiceId;
          params.buyQuantity = this.enoughNow.buyQuantity;
        }


        //获得地址ID
        this.adrList.forEach((element)=>{
          if(element.isDefault){
            params.addressId= element.id;
          }
        })
        this.detail.curingServiceList.forEach((item)=>{
          zhugeObj.track({
            title : '购物袋',
            content : {
              '服务项名称' : item.name,
              '服务量数量' : item.buyQuantity,
              '养护数量' : this.defaultIndex
            }
          })
        })
      
        homeApi.submitCart(params).then((res)=>{
          if(res.realAmount != 0){
            this.$router.push({name:'pay',query:{id:res.orderCode}})
          }else{
            this.$router.push({name:'paySuccess'});
          }
        })
      },
      choseAdr(){
        if(this.adrList.length == 0){
          this.$router.push({ name: 'addressEdit'})
        }else{
          this.adrShow = true;
        }
      },
      getAdressList(){
        myApi.customerAddress({}).then((res)=>{
          let defaultNum = 0;
          let index = 0;
          let mostTime = '1970-01-01'
          res.forEach((element,index)=>{
            element.trueDefault = element.isDefault;
            if(element.isDefault){
              defaultNum++;
            }
            let mostDate = new Date(mostTime).getTime();
            let elementDate = new Date(element.updateTime).getTime();
            if(elementDate>mostDate){
              mostTime = element.updateTime;
              index = index;
            }
          })

          if(defaultNum == 0 && res.length != 0){
            res[index].isDefault = true;
          }


          this.adrList = res;

          this.getShoppingCart();
        })
      },
      adrClick(index){
        
        this.adrList.forEach((element,idx) => {
            if(index == idx){
              element.isDefault = true;
            }else{
              element.isDefault = false;
            }
        });
        this.adrShow = false;
        //todo判断地址是否可以包邮
        this.getShoppingCart();

      },
      freePostage(areacode){
        
      },
      getShoppingCart(){
        let adrId;
        this.adrList.forEach((item)=>{
          if(item.isDefault){
            adrId = item.id;
          }
        })
        let params = {
          addressId : adrId,
          action : 'normal'
        }
        if(this.enoughNowTag){
          params.curingServiceId = this.enoughNow.curingServiceId;
          params.buyQuantity = this.enoughNow.buyQuantity;
        }
        homeApi.getShoppingCart(params).then((res)=>{
          res.curingServiceList.forEach(element=>{
            // if(element.selected){
            //   element.checkRadio = true;
            // }
            element.selected?element.checkRadio = true:element.checkRadio = false

          })
          this.detail =  res;
        })
      },

    }
  }
</script>

<style scoped lang="scss">
.width500{
  width: 500px;
}

.g-fixed-bottom1{
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 10;
    width: 100%;
    height: 1.44rem;
    padding: 0rem 0.4rem 0;
    padding-right:0;
    box-sizing: border-box;
    -webkit-transform: translateZ(0);
    background: #fff;
    box-shadow: 0 0.02667rem 0.26667rem 0 rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: space-between;
}
.fl{
  float: right;
  margin-top: 30px;
}
.li_div{
  display: flex;
  height: 100%;
}
.rightPicker{
  text-align: right;
  justify-content: flex-end;
  background:  url("/images/public/grey_row.png") no-repeat right;
  background-size:12px; 
  padding-right: 25px;
}
.picker{
  width: 400px;
  height: 40px;
}
.radio_top{
  margin-top: 68px;
}
.line_bg{
  width: 100%;
  height: 16px;
  background: #f8f8f8;
}
.border_b{
   border-bottom:1px solid #f5f5f5;
}
.left_cont{
  font-size:26px!important; 
  color:#333333!important;
  span{
    font-size:40px; 
    margin-left: 5px;
    position: relative;
    top:-3px;
    font-weight:500; 
  }
}
.right_cont{
  margin-right: 0!important;
}
.del_img{
  width: 38px;
  margin-right: 36px!important;
}
.g-fixed-bottom{
  padding-top: 0;
}
.number_name{
  font-weight: 500;
  span{
    font-weight: 400;
    font-size: 24px;
    color:#aab2bd;
  }
}
.name_content{
  display: flex;
  justify-content: space-between;
  line-height: 40px;
  margin-top:-2px
}
.f24{
  font-size: 24px;
}
.oneClamp{
  font-size:28px;

}
.colorGrey{
  color: #999;
}
 textarea::-webkit-input-placeholder {
      /* placeholder颜色  */
    color: #ccc!important;
      /* placeholder字体大小  */
      font-size: 28px;
      /* placeholder位置  */
      text-align: right;
  }
  textarea::-webkit-input-placeholder {
  /* WebKit browsers */
    color: #ccc;
  }
  .no_content{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .no-list{
    width:100%;
    margin-top: 0px;
  }
  .remark{
    text-align: right;
  }
  .place-order{
    padding-bottom:120px;
    .goods{
      padding: 40px 30px 60px;
      padding-bottom:0; 
      padding-top: 0;
      li{
        display: flex;
        position: relative;
        margin-top:40px;
        // margin-bottom: 40px; 
        padding-bottom: 40px;
        .select{
          width: 32px;
          flex: none;
          margin-right: 16px;
          // display: flex;
          // align-items: center;
        }
        .img{
          width: 160px;
          height: 160px;
          flex: none;
          overflow: hidden;
          border: 1px solid #eee;
          border-radius:6px; 
          img{
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .info{
          flex: auto;
          margin-left: 20px;
          .name{
            width: 336px;
            line-height: 40px;
            font-weight: 500;
          }
          .category{
            line-height: 34px;
            margin-top: 6px;
          }
          .tool-bar{
            width: 100%;
            margin-top: 41.5px;
            display: inline-flex;
            justify-content: space-between;
            .total-amount{
              font-weight: 500;
              line-height: 53px;
            }
          }
        }
      }
    }
    .list{
      padding: 0 30px;
      // margin-top: 58px;
      li{
        width: 100%;
        min-height: 104px;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #eee;
        &>div{
          display: flex;
          align-items: center;
          font-size:28px;
          img{
            width: 40px;
            height: 40px;
            object-fit: cover;
            margin-right: 15px;
          }
          input{
            height: 104px;
            border: none;
            font-size:28px;
            &.remark{
              width: 500px;
            }
            &.num{
              text-align: right;
            }
            &::placeholder{
              text-align: right;
            }
          }
        }
      }
    }
    .toolbar{
      // display: flex;
      // flex-direction: row-reverse;
      // align-items: center;
      // justify-content: space-between;
      &>div{
        color: $theme-color;
        display: flex;
        align-items: center;
        margin-right: 44px;
        img{
          width: 38px;
          height: 44px;
          object-fit: cover;
          margin-right: 14px;
        }
      }
    }
  }


  .containerAdr{
    height: 860px;
    padding: 32px;
    position: relative;
    padding-bottom:60px;
    padding-top: 0px;
    .title{
      line-height: 90px;
      border-bottom:1px solid #EEEEEE;
      font-size: 28px;
      font-weight:500; 
    }
    &>span{
      position:absolute;
      right:30px;
      top:80px;
      color:#7ADFDF;
    }
    .addr-container{
      height: 700px;
      overflow-y: scroll;
      ul li{
        width: 100%;
        display: flex;
        padding-top:32px;

        // align-items: center;
      }
    }
    .close{
      width: 36px;
      height: 36px;
      position: absolute;
      top: 30px;
      right: 30px;
      background: url("/images/public/close.png") no-repeat center;
      background-size: 32px;
    }
    .submit{
      position: absolute;
      bottom: 30px;
      right: 30px;
    }
  }
</style>
